module.exports = __webpack_public_path__ + "static/media/btn_google_light_normal_ios.1cdc8fce.svg";